require("./threepl-service-chips.scss");

import {ChangeDetectionStrategy, Component, computed, inject, input} from "@angular/core";
import {TranslateService} from "@ngx-translate/core";

@Component({
  selector: "app-threepl-service-chips",
  templateUrl: "./threepl-service-chips.html",
  standalone: false,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ThreeplServiceChipsComponent {
  readonly items = input<string[]>([]);
  readonly maxItems = input(1);

  private readonly translate = inject(TranslateService);

  readonly shown = computed(() => (this.items() ?? []).slice(0, this.maxItems()));
  readonly extra = computed(() => (this.items() ?? []).slice(this.maxItems()));
  readonly extraTooltip = computed(() => this.extra().map((item) => this.translate.instant(item)).join(", "));
}
